<template>
  <div>
    <b-modal
      v-model="showModal"
      v-bind="$attrs"
      v-on="$listeners"
      header-class="px-4 px-lg-5"
      body-class="pt-3 pb-5 px-4 px-lg-5"
      hide-footer
    >
      <template #modal-title>
        <slot name="title">{{ title }}</slot>
      </template>
      <slot />
    </b-modal>
  </div>
</template>

<script>
import { defineComponent, computed } from '@vue/composition-api'

export default defineComponent({
  name: 'BaseModal',
  props: {
    value: Boolean,
    title: {
      type: String,
      default: ''
    }
  },  
  computed: {
    modalValue: {
      get() { return this.value },
      set(v) { this.$emit("input", v) }
    }
  },
  emits: ['input'],
  setup(props, { emit }) {
    const showModal = computed({
      get: () => props.value,
      set: (newValue) => emit('input', newValue)
    })

    return {
      showModal
    }
  }
})
</script>
